import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["hidden"]
  static targets = ["checkboxContainer", "numberField", "select"]

  showNumberField({ target }) {
    if (target.value === "Other") {
      this.#hide(target)
      target.value = ""
      target.disabled = true
      this.#show(this.checkboxContainerTarget)
      this.numberFieldTarget.disabled = false
      this.#show(this.numberFieldTarget)
      this.numberFieldTarget.focus()
    }
  }

  hideNumberField({ target }) {
    this.#hide(this.checkboxContainerTarget)
    target.checked = true
    this.#hide(this.numberFieldTarget)
    this.numberFieldTarget.disabled = true
    this.selectTarget.disabled = false
    this.#show(this.selectTarget)
  }

  #hide(target) {
    target.classList.add(this.hiddenClass)
  }

  #show(target) {
    target.classList.remove(this.hiddenClass)
  }
}
